@if ((isTabletOrBigger$ | async) === false && showFacettenFilterbuttonMobil) {
  <div class="d-print-none d-flex mb-2 mb-lg-3 justify-content-end">
    <button
      class="now-btn now-btn-secondary gap-2 d-flex justify-content-center d-lg-none"
      [ngClass]="isSmartPhone() ? 'w-100' : 'w-auto'"
      aria-label="Öffne Optionen zum Filtern und Sortieren"
      data-bs-toggle="offcanvas"
      data-bs-target="#facetten-mobile"
      id="filter_anzeigen_mobile"
    >
      <span class="now-icon now-icon-sliders-horizontal"></span>
      <span class="d-block">Filtern ({{ aktiveFilterService.anzahlAktiveFilter$ | async }})</span>
    </button>
  </div>
}
